import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LandingPage } from './pages/LandingPage';
import { BookingPage } from './pages/BookingPage';
import { ImpressumPage } from './pages/ImpressumPage';
import { DatenschutzPage } from './pages/DatenschutzPage';
export function App() {
  return <HelmetProvider data-id="element-0" data-mp="2rkx3hddxwbly">
      <Router data-id="element-1" data-mp="2rkdx8txnjbnr">
        <Routes data-id="element-2" data-mp="2rlyrsjjyuulm">
          <Route path="/" element={<LandingPage data-id="element-4" data-mp="2rit3h6j5vwqy" />} data-id="element-3" data-mp="2rlf7iw6ufu4f" />
          <Route path="/free-strategy-call" element={<BookingPage data-id="element-6" data-mp="2mndq0fp2g2v2" />} data-id="element-5" data-mp="2mm2n0i3g2z50" />
          <Route path="/legal-notice" element={<ImpressumPage data-id="element-8" data-mp="31b8lg3ugklbu" />} data-id="element-7" data-mp="2mjzmh44o1nm1" />
          <Route path="/privacy-policy" element={<DatenschutzPage data-id="element-10" data-mp="31cjjro54x0vk" />} data-id="element-9" data-mp="31bi8bik7icdb" />
        </Routes>
      </Router>
    </HelmetProvider>;
}